export const getGovlaunchUrl = () => {
  return process.env.NEXT_PUBLIC_GOVLAUNCH_URL || process.env.GOVLAUNCH_URL;
};
